<template>
  <div style="display: flex; flex-direction: column">
    <div
      style="
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 24px;
        margin-top: 10px;
        margin-left: 20px;
      "
    >
      <div style="width: 320px">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-combobox
              v-model="dateRange"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              dense
              hide-details
              @click="menu = true"
              @click:prepend="resetDate()"
            ></v-combobox>
          </template>
          <v-date-picker
            v-model="dates"
            scrollable
            range
            :allowed-dates="allowedDates"
            @input="updateDateRange"
            :min="'2016-01-01'"
            :max="maxDate"
          >
            <v-spacer></v-spacer>
            <v-btn text style="font-weight: bold" @click="menu = false"
              > {{ $t("_annuler_") }}</v-btn
            >
            <v-btn text color="primary" @click="checkgoodperiode"
              >{{ $t("_valider_") }}</v-btn
            >
          </v-date-picker>
        </v-menu>
      </div>

      <div style="display: flex; align-items: center">
        <select
          v-model="timestep"
          style="
            padding: 4px 8px;
            border: 1px solid #ccc;
            border-radius: 15px;
            background: lightgrey;
          "
        >
          <option
            v-for="timestepOption in timestepOptions"
            :value="timestepOption.value"
            :key="timestepOption.value"
          >
            {{ timestepOption.label }}
          </option>
        </select>
      </div>
    </div>

    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0px 5px;
      "
    >
      <div style="display: flex; align-items: center">
        <span style="margin-right: 10px; color: black; margin-top: -3px">{{
          $t("_evolution_parc_")
        }}</span>
        <v-switch
          :label="$t('_evolution_centrales_')"
          color="orange"
          v-model="evolutiontype"
        ></v-switch>
      </div>
    </div>
    <div style="margin-left: 15px; gap: 5px; margin-top: -15px">
      <v-radio-group v-model="radios" row>
        <v-radio :label="$t('_pr_')" value="pr" color="orange"></v-radio>
        <v-radio
          v-if="raw_var"
          :label="$t('_pertes_vs_modele_energie_')"
          value="pertes"
          color="orange"
        ></v-radio>
        <v-radio
          v-if="raw_var"
          :label="$t('_eac_')"
          value="eac"
          color="orange"
        ></v-radio>
        <!--  <v-radio :label="$t('_evolution_dc_')" value="dc" color="orange"></v-radio>-->
        <v-radio
          :label="$t('_disponibilite_')"
          value="disponibilite"
          color="orange"
        ></v-radio>
        <v-radio
          v-if="raw_var"
          :label="$t('_actionable_losses_')"
          value="actionable"
          color="orange"
        ></v-radio>
      </v-radio-group>
    </div>
    <div>
      <v-card elevation="0">
        <plotly
          :key="`${change_size ? 'small' : 'large'}-${graph_key}`"
          ref="graph"
          :data="graph_data['data_render']"
          :layout="graph_data['layout_render']"
          :displayModeBar="true"
        />
        <LoadingDialog v-if="loading" :is_loading="loading" />
        <v-alert v-if="showNoDataAlert" type="warning" dense text class="mt-3">
          {{ $t("_donnees_manquantes_") }}
        </v-alert>
      </v-card>
    </div>
    <!-- <v-btn style="margin: 10px; margin-top: 10px; width: 300px;">{{ $t("_telecharger_le_tableau_comparatif_") }}</v-btn>-->
    <p></p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/api/api";
import { Plotly } from "vue-plotly";
import LoadingDialog from "@/components/Utils/LoadingDialog";

export default {
  components: {
    Plotly,
    LoadingDialog,
  },
  props: {
    selected_site_id: { type: Array, default: () => [] },

    change_size: {
      type: Boolean,
    },
  },

  data() {
    const today = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    const storeddates = JSON.parse(localStorage.getItem("storeddates"));
    const GRAPH_MAPPING = {
      // when evolutiontype is true (centrales)
      true: {
        pr: { key: "pr", title: "_evolutions_pr_centrales_" },
        pertes: { key: "pertes", title: "_evolutions_pertes_centrales_" },
        actionable: {
          key: "actionable",
          title: "_evolutions_actionable_centrales_",
        },
        dc: { key: "dc", title: "_evolutions_dc_centrales_" },
        disponibilite: {
          key: "availability",
          title: "_evolutions_disponibilite_centrales_",
        },
        eac: { key: "eac", title: "_eac_" },
      },
      // when evolutiontype is false (parc)
      false: {
        pr: { key: "pr_parc", title: "_evolution_pr_parc_" },
        pertes: { key: "pertes_parc", title: "_evolution_pertes_parc_" },
        actionable: {
          key: "actionable_parc",
          title: "_evolution_actionable_parc_",
        },
        dc: { key: "dc_parc", title: "_evolution_dc_parc_" },
        disponibilite: {
          key: "availability_parc",
          title: "_evolution_disponibilite_parc_",
        },
        eac: { key: "eac_parc", title: "_evolution_eac_parc_" },
      },
    };

    return {
      loading: false,
      menu: false,
      today,
      oneYearAgo,
      initialLoadDone: false,
      maxDate: new Date(Date.now() - 86400000).toISOString().substr(0, 10),
      dates: storeddates || [
        oneYearAgo.toISOString().slice(0, 10),
        today.toISOString().slice(0, 10),
      ],
      dateRange: storeddates
        ? `${storeddates[0]} -> ${storeddates[1]}`
        : `${this.formatDate(oneYearAgo)} -> ${this.formatDate(today)}`,
      radios: localStorage.getItem("storedradios") || "pr",
      count: 0,
      listsite: [],
      evolution: [],
      timestep: "monthly",
      showNoDataAlert: false,
      label_y_axis: "_evolutions_",
      evolutiontype: false,
      raw_var: true,
      graph_key: 0,
      GRAPH_MAPPING,
      graph_data: {
        data_render: [],
        layout_render: {
          title: {
            text: "Evolution DC centrale Alexandre I",
            x: 0.1,
          },
          yaxis: {
            title: this.$t("_evolutions_"),
            position: 0,
            autorange: "true",
            rangemode: "tozero",
          },
          margin: {
            l: 70,
            r: 40,
            b: 60,
            t: 50,
          },
          hovermode: "closest",
        },
      },
    };
  },

  mounted() {
    this.refreshDates();
    this.change_title();    
    this.radios ='pr'
  },

  watch: {
    //   choosesites(newChoosesites) {
    //   // Recalculate total when choosesites changes
    //   this.total = newChoosesites.length - 1;
    // },
    radios(newRadios) {
      localStorage.setItem("storedradios", newRadios);
      this.change_title();
      if (!this.evolution || Object.keys(this.evolution).length === 0) {
        this.resetGraph();
        return;
      }
      if (newRadios === "eac") {
        this.label_y_axis = "_evolutions_kwh_";
      } else {
        this.label_y_axis = "_evolutions_%_";
      }
      this.extract_data_graph();

      this.graph_data.layout_render.yaxis.title = this.$t(this.label_y_axis);
    },
    evolutiontype: {
      handler() {
        this.extract_data_graph();
        this.change_title();
      },
      immediate: true,
    },
    timestep: {
      handler(newTimestep) {
        this.refreshDates();
        if (newTimestep === "raw" || newTimestep === "hourly") {
          this.raw_var = false;
        } else {
          this.raw_var = true;
        }
      },
    },
  
    selected_site_id: {
      async handler(newVal) {
        this.evolution = {};
        this.graph_data.data_render = [];
        this.showNoDataAlert = false;
        this.graph_key += 1;
        if (!newVal || newVal.length === 0) {
          this.refreshDates();
          return;
        }      
        this.checkgoodperiode();
      },
      immediate: true,
    },
  },

  computed: {
    ...mapGetters(["role", "installations", "cur_install_id", "constants"]),
    

    formattedDates: {
      get() {
        return this.dates;
      },
      set(newdates) {
        if (!newdates[1]) {
          this.dates = [newdates[0], newdates[0]];
        } else {
          this.dates = newdates;
        }
      },
    },

    timestepOptions() {
      // const diffTime = Math.abs(
      //   new Date(this.dates[0]) - new Date(this.dates[1])
      // );
      // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return [
        // {
        //   label: this.$t("_donnees_brutes_"),
        //   value: "raw",
        //   active: diffDays <= 7,
        // },
        // {
        //   label: this.$t("_heure_"),
        //   value: "hourly",
        //   active: diffDays <= 30,
        // },
        {
          label: this.$t("_journee_"),
          value: "daily",
          active: true,
        },
        {
          label: this.$t("_semaine_"),
          value: "weekly",
          active: true,
        },
        {
          label: this.$t("_mois_"),
          value: "monthly",
          active: true,
        },
        {
          label: this.$t("_annee_"),
          value: "yearly",
          active: true,
        },
      ].filter((t) => t.active);
    },
  },

  methods: {
    getGraphConfig() {
      const typeConfig = this.GRAPH_MAPPING[this.evolutiontype];
      return typeConfig ? typeConfig[this.radios] : null;
    },

    resetGraph() {
      this.evolution = [];

      this.graph_data.data_render = [];

      // ✅ ONLY update the title, don't replace layout 
      // this.graph_data.layout_render.title.text = this.$t(
      //   "_donnees_manquantes_"
      // );

      this.showNoDataAlert = true;

      this.graph_key += 1;
    },
    async waitForData() {
      // Wait until installations and selected_site_id are populated
      while (
        !this.installations ||
        this.installations.length === 0 ||
        !this.selected_site_id ||
        this.selected_site_id.length === 0
      ) {
        await new Promise((resolve) => setTimeout(resolve, 100)); // wait 100ms
      }
    },
    resetDate() {
      this.dates = [
        this.oneYearAgo.toISOString().slice(0, 10),
        this.today.toISOString().slice(0, 10),
      ];
      this.updateDateRange();
    },

    allowedDates(date) {
      return date <= this.maxDate && date >= "2016-01-01";
    },

    checkgoodperiode() {
      if (this.dates[1] == null) {
        this.dates[1] = this.dates[0];
      }
      const diffTime = Math.abs(
        new Date(this.dates[0]) - new Date(this.dates[1])
      );
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (this.timestep == "hourly" && this.dates[0] != this.dates[1]) {
        if (diffDays <= 30) {
          this.refreshDates();
        } else {
          this.timestep = "daily";
          this.refreshDates();
        }
      } else if (this.timestep == "raw" && this.dates[0] != this.dates[1]) {
        if (diffDays <= 7) {
          this.refreshDates();
        } else if (diffDays > 7 && diffDays <= 30) {
          this.timestep = "hourly";
          this.refreshDates();
        } else {
          this.timestep = "daily";
          this.refreshDates();
        }
      } else {
        this.refreshDates();
      }
    },

    change_title() {
      const config = this.getGraphConfig();
      if (config) {
        this.graph_data.layout_render.title.text = this.$t(config.title);
      }
    },

    formatDate(date) {
      return date.toISOString().slice(0, 10);
    },

    updateDateRange() {
      if (this.dates && this.dates.length > 0) {
        if (!this.dates[1]) {
          this.dateRange = `${this.dates[0]} -> ${this.dates[0]}`;
        } else {
          let [startDate, endDate] = this.dates.sort(
            (a, b) => new Date(a) - new Date(b)
          );
          this.dateRange = `${startDate} -> ${endDate}`;
        }
      } else {
        this.dateRange = "";
      }
    },


    changeidbyname(person) {
      let name = "";

      this.installations.forEach((element) => {
        if (element.installation_id == person) {
          name = element.installation_name;
        }
      });

      return name;
    },

    async refreshDates() {
      this.menu = false;
      this.evolution = {};
      this.graph_data.data_render = [];
      this.graph_key += 1;
      if (!this.selected_site_id || this.selected_site_id.length === 0) {
        this.resetGraph();
        return;
      }
      if (this.count != 0) {
        this.loading = true;
      }
      this.count++;
      this.graph_data.data_render = [];
      this.graph_key += 1;
      try {
        const response = await api.getgraphfleetevolution({
          dates: this.dates,
          choosesite: this.selected_site_id,
          periode: this.timestep,
        });
        if (response && response.data) {
          this.evolution = response.data;

          // ✅ Check if there’s actual graph data
          if (!response.data || Object.keys(response.data).length === 0) {
            this.resetGraph();
          } else {
            this.showNoDataAlert = false;
            await this.extract_data_graph();
            // localStorage.setItem("storeddates", JSON.stringify(this.dates));
          }

          this.loading = false;
        }
      } catch (error) {
        this.showNoDataAlert = true;
      } finally {
        this.loading = false;
      }
    },

    toggleSelectAll() {
      if (this.choosesAllSites) {
        this.choosesites = [];
      } else {
        this.choosesites = this.listsite;
      }
    },

    extract_data_graph() {
      if (!this.evolution || Object.keys(this.evolution).length === 0) {
        this.resetGraph();
        return;
      }
      this.graph_data.data_render = [];

      const config = this.getGraphConfig();
      if (!config) return []; // Guard clause if selection doesn't exist

      const info = this.evolution[config.key] || [];

      Object.entries(info).forEach(([person, values]) => {
        // 1. Determine the name based on evolutiontype
        const name = this.evolutiontype ? this.changeidbyname(person) : person;

        // 2. Determine the unit percentage sign based on radios
        const unit = this.radios !== "eac" ? "%" : "";

        // 3. Determine the date format based on evolutiontype
        const dateX = !this.evolutiontype ? "<br>%{x|%d/%m/%Y %H:%M}" : "";

        // 4. Construct the single object using the variables above
        let render = {
          x: [],
          y: [],
          type: "line",
          name: name,
          hovertemplate: `<b>${name}</b><br>%{y}${unit}${dateX}<extra></extra>`,
        };
        Object.entries(values).forEach(([date, value]) => {
          render.x.push(date.replace(" ", "T")); // Or new Date(date).toISOString()
          render.y.push(value);
        });

        this.graph_data.data_render.push(render);
      });
      return info;
    
    },
  },
};
</script>

<style>
select {
  background-color: #eef1f8;
  border-radius: 20px;
  border: none;
  padding-top: 4px;
  padding-bottom: 4px;
  height: 100%;
  max-width: 100%;
}
.v-menu__content {
  min-width: 290px !important;
}
.v-label {
  color: black !important;
}
</style>
